export default __webpack_public_path__ + "static/free-sample-1-2-bb62bb86d4b4b5d601d4784589f4de47.jpg";